module.exports = __webpack_public_path__ + "img/tags-hsia.a04dd2f3.webp";